import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='legal-information'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'>
          Disclosures and Legal Information
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual&#174; is a trademark of The Northwestern Mutual Life Insurance Company.
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual is the marketing name for The Northwestern Mutual Life Insurance Company, Milwaukee, WI (NM) (life and disability insurance, annuities and life insurance with long&#45;term care benefits) and its subsidiaries.
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Long Term Care Insurance Company, Milwaukee, WI (NLTC) (long&#45;term care insurance), is a subsidiary of NM.
        </Typography>
        <Typography nextElement='typography'>
          <Typography component='span' weight={400}>Northwestern Mutual Investment Services, LLC (NMIS)</Typography>, is a subsidiary of NM, broker&#45;dealer, registered investment adviser, member <Link linkUrl='https://www.finra.org/' isOutgoingLink variant='primaryDeemphasize'>FINRA</Link> and <Link linkUrl='https://www.sipc.org/' isOutgoingLink variant='primaryDeemphasize'>SIPC</Link>.
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual Wealth Management Company&#174;, Milwaukee, WI, (NMWMC) (investment advisory and trust services) is a subsidiary of NM and federal savings bank. Investment products and trust services are not insured by the FDIC, are not deposits or other obligations of, or guaranteed by, NMWMC or its affiliates and are subject to investment risks, including possible loss of the principal amount invested.
        </Typography>
        <Typography nextElement='typography'>
          Estate Strategies Group (ESG) is a division of NMWMC.
        </Typography>
        <Typography nextElement='typography'>
          Strategic Employee Benefit Services is a marketing program in which local independently owned and operated companies that are not subsidiaries or affiliates of NM provide comprehensive employee benefit services. Strategic Employee Benefit Services provides Northwestern Mutual Financial Representatives with access to a variety of top employee benefit companies.
        </Typography>
        <Typography nextElement='typography'>
          A financial professional can include any of the following: Financial Representatives are life insurance agents of The Northwestern Mutual Life Insurance Company (NM) and may be registered representatives of NMIS to offer investment brokerage services. In addition to being licensed as life insurance agents with NM and registered representatives of NMIS, only those financial professionals with &#34;Advisor&#34; in their title or who otherwise disclose their status as an advisor of NMWMC are also credentialed to provide investment advisory services as representatives of NMWMC.
        </Typography>
        <Typography nextElement='typography'>
          Products and services referenced are offered and sold only by appropriately appointed and licensed entities and financial advisors. Financial professionals might not represent all entities shown or provide all the services discussed. Not all products and services are available in all states.
        </Typography>
        <Typography nextElement='typography'>
          The information contained in this website, including any <Link linkUrl='/third-party-links/' variant='primaryDeemphasize'>links to other websites</Link>, is provided for general informational purposes as a convenience to Northwestern Mutual customers and Internet users. This information is not a substitute for obtaining professional advice from a qualified person, firm or corporation. Therefore, you should not rely solely upon this information in making any decision, including any decision to buy a product from Northwestern Mutual or any other company. This information, including any prospectus information, is not an offer to sell or a solicitation of an offer to buy any security, service, or product. This is not intended to provide legal or tax advice. Please consult your legal or tax professional for specific information.
        </Typography>
        <Typography nextElement='typography'>
          Federal Law requires that Northwestern Mutual obtain, verify and record information that identifies each owner. As part of that process, the owner will be asked to provide the following: name, address, date of birth (as applicable) and other information. Northwestern Mutual may utilize information from the owner's driver&#39;s license, other government issued identification or other means, including third party sources, to verify identity.
        </Typography>
        <Typography component='h2'
          nextElement='typography'>
          Policy&#47;Contract Form Numbers for Corporate Website
        </Typography>
        <Typography nextElement='typography'>
          State Variations to the form numbers may apply. Not all policies&#47;contracts are available in every state.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Life Insurance Policy Forms
        </Typography>
        <Typography
          component='h4'
          nextElement='typography'>
          Whole Life Insurance &#38; Related Benefits
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'Individual Whole Life, ICC17.UU.WL.(0119)' },
            { bulletText: 'Blended Term Benefit, ICC17.UU.WL.BTB.(0119)' },
            { bulletText: 'Additional Premium Benefit, ICC17.UU.WL.AP.(0119)' },
            { bulletText: 'Waiver of Premium Benefit, ICC17.UU.WL.WP.(0119)' },
            { bulletText: 'Accelerated Care Benefit, ICC18.UU.ACB.(0119)' },
            { bulletText: 'Accidental Death Benefit, NN 1 Life ADB' },
            { bulletText: 'Survivorship Whole Life, ICC17.UU.SWL.(0119)' },
            { bulletText: 'Survivorship Blended Term Benefit, ICC17.UU.SWL.BTB.(0119)' },
            { bulletText: 'Survivorship Additional Premium Benefit, ICC17.UU.SWL.AP.(0119)' },
            { bulletText: 'Survivorship Waiver of Premium Benefit, ICC17.UU.SWL.WP.(0119)' },
            { bulletText: 'Additional Purchase Benefit, ICC17.UU.APB.(0119)' },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Term
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'Term 80, ICC12.TT.TERM.(0513)' },
            { bulletText: 'Term 10, ICC12.TT.TERM.(0513)' },
            { bulletText: 'Level Term 10, ICC12.TT.TERM.(0513)' },
            { bulletText: 'Level Term 20, ICC12.TT.TERM.L20.(0513)' },
            { bulletText: 'One Year Term, NN 24' },
            { bulletText: 'Waiver of Premium Benefit, NN 1,2,4,5 WP' },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          General Account Universal Life and Variable Life
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Custom Universal Life &#8212; ICC18.UU.CUL.(0919)</> },
            { bulletText: 'Survivorship Universal Life, ICC18.UU.SUL.(0919)' },
            { bulletText: 'Single Premium Universal Life, UU.SPUL.(1219)' },
            { bulletText: 'Single Premium Universal Life, ICC18.UU.SPUL.P.(1219)' },
            { bulletText: 'Variable Universal Life Plus, UU.VULP.(1019)' },
            { bulletText: 'Executive Variable Universal Life, UU.EVUL.(1019)' },
            { bulletText: 'Waiver Benefit, ICC18.CUL.SMP.(0919)' },
            { bulletText: 'Waiver Benefit, ICC18.SUL.SMP.(0919)' },
            { bulletText: 'Waiver Benefit UU.VUL.SMP.(1019)' },
            { bulletText: 'Additional Purchase Benefit (VUL) UU.VULP.APB.(1019)' },
            { bulletText: 'Disability Waiver of Premium Benefit, TT.SCL.WP.(0608)' },
            { bulletText: 'Death Waiver of Premium Benefit, TT.SCL.SWP.(0608)' },
            { bulletText: <>Policy Split Benefit &#126; TT.SCL.PS.(0608)</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Annuity Contract Forms
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: 'Fixed Annuities' },
            { bulletText: <>Single Premium Retirement Annuity (1 &#38; 3 year) &#126; ICC12.RS.SPRA.(0313)</> },
            { bulletText: <>Single Premium Retirement Annuity (5 year) &#126; ICC12.RS.SPRA.5.(0313)</> },
            { bulletText: <>Single Premium Retirement Annuity (long duration) &#126; ICC12.RS.SPRA.LD.(0313)</> },
            { bulletText: <>Retirement Annuity Policy &#126; NN.RA.(0608)<sup>1</sup></> },
            { bulletText: <>Single Premium Deferred Income Annuity &#126; ICC16.NN.DIA.(1116)</> },
            { bulletText: <>Single Premium Immediate Annuity &#126; ICC11.NN.SPIA.(0511)</> },
            { bulletText: <>Single Premium Deferred Income Annuity (Portfolio Based) &#126; ICC17.UU.PDIA.(0717)</> },
            { bulletText: <>Single Premium Immediate Income Annuity (Portfolio Based) &#126; ICC17.UU.PSPIA.(0717)</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Variable Annuities
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Flexible Payment Variable Annuity&#8212;Account A&#8212;Front&#45;load version &#126; ICC12.RR.VA.AFR.(0313), Flexible Payment Variable Annuity&#8212;Account A&#8212;Back&#45;load version &#126; ICC12.RR.VA.ABK.(0313), Flexible Payment Variable Annuity&#8212;Account B &#8212;Front&#45;load version &#126; ICC12.RR.VA.BFR.(0313), Flexible Payment Variable Annuity&#8212;Account B&#8212;Back&#45;load version &#126; ICC12.RR.VA.BBK.(0313), Flexible Payment Variable Annuity&#8212;Account A&#8212;Fee Based version &#126; ICC12.RR.VA.AFB.(0313), Flexible Payment Variable Annuity&#8212;Account C&#8212;Network Edition version &#126; ICC12.RR.VA.CNE.(0313), Group Variable Annuity&#8212;Account C &#126; NPV.1C.(0594)</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Annuity Benefits
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Deferral Period Death Benefit Amendment &#126; ICC16.DIA.DPDB.AMDT.(1116), Deferral Period Death Benefit Amendment &#126; ICC17.PDIA.DPDB.AMDT.(0717), Enhanced Death Benefit &#126; ICC12.VA.EDB.(0313), Enhanced Death Benefit (Network Edition) &#126; ICC12.VA.EDB.CNE.(0313), Exchange Option Amendment &#126; ICC17.UU.EO.AMDT.(0717), Waiver of Withdrawal Charge &#126; ICC09.VA.WWC.(032000) Qualified Longevity Annuity Contract Amendment &#126; ICC17.QLAC.AMDT.(0717), Return of Premium Benefit Amendment &#126; ICC17.QLACRP.AMDT.(0717), Waiver of Premium Benefit &#126; NN.R.A.WP.(0608), Waiver of Premium Benefit &#126; NN.R.I.WP.(0608)<sup>2</sup></> },
          ]}
        />
        <Typography
          component='h3'
          nextElement='typography'>
          Disability Insurance Policy Forms
        </Typography>
        <Typography
          component='h4'
          nextElement='typography'>
          Individual Disability Insurance Policy Forms:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Non&#45;Cancellable Disability Income &#126; ICC16.TT.NCDI.(0916)</> },
            { bulletText: <>Guaranteed Renewable Disability Income &#126; ICC16.TT.GRDI.(0916)</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Disability Overhead Expense Policy Form:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Disability Overhead Expense &#126; ICC16.TT.DOE.(0916)</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Disability Business Products:
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Disability Keyperson &#126; TT.KEY.(0617)3 or RR.KEY.(0101)</> },
            { bulletText: <>Disability Buyout Expense Reimbursement &#126; TT.BUY.(0617) or RR.BUY.(0101)</> },
            { bulletText: <>Group Short Term Disability &#126; MN 992&#8211;STD</> },
            { bulletText: <>Group Long Term Disability &#126; MN 992&#8211;LTD</> },
            { bulletText: <>Group LTD Conversion &#126; MN 992&#8211;CONV</> },
            { bulletText: <>Small Group Long Term Disability &#126; MN 1096&#8211;SGLTD</> },
            { bulletText: <>Small Group Short Term Disability &#126; MN 1096&#8211;SGSTD</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Disability Insurance Benefits
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>Partial Disability Benefit &#126; ICC16.TT.DI.PDB.(0916)</> },
            { bulletText: <>Partial Disability Benefit Option &#126; ICC16.TT.DI.PDBO.(0916)</> },
            { bulletText: <>Additional Purchase Benefit &#126; ICC16.TT.DI.APB.(0916),  ICC16.TT.DOE.APB.(0916)</> },
            { bulletText: <>Indexed Income Benefit &#126; ICC16.TT.DI.IIB.(0916)</> },
            { bulletText: <>Future Increase Benefit &#126; ICC16.TT.DI.FIB.(0916), ICC16.TT.DOE.FIB.(0916)</> },
            { bulletText: <>Extended Mental Disorder and Substance Abuse Benefit &#126; ICC16.TT.DI.EMB.(0916)</> },
            { bulletText: <>Catastrophic Disability Benefit &#126; ICC16.TT.DI.CAT.(0916)</> },
            { bulletText: <>Medical Own Occupation Option &#126; ICC16.TT.DI.MED.(0916)</> },
            { bulletText: <>Transitional Own Occupation Option &#126; ICC16.TT.DI.TRA.(0916)</> },
            { bulletText: <>True Own Occupation Option &#126; ICC16.TT.DI.TRU.(0916)</> },
            { bulletText: <>Additional Purchase Benefit &#126; TT.BUY.APB.(0617)</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Long&#45;term Care Insurance Policy Forms
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>UU.LTC.(1014) or UU.LTC.(0916), Individual long&#45;term Care Insurance Policy.</> },
          ]}
        />
        <Typography
          component='h4'
          nextElement='typography'>
          Long&#45;term Care Insurance Benefit
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            { bulletText: <>TT.LTC.ABI.(1010) &#126; Automatic Benefit Increase, Automatic Additional Purchase Benefit &#126; TT.LTC.APB.(1010), Paid&#45;Up Nonforfeiture Benefit &#126; TT.LTC.NFB.(1010), Paid&#45;Up Nonforfeiture&#47;Contingent Benefit &#126; TT.LTC.(NFBC.(1010), Survivorship Benefit &#126; TT.LTC.SB.(1010)</> },
            { bulletText: <>NM&#8211;DIS (0719)</> },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
